import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthentificationService, ContextService, NavigationService } from '@kiraah-shared/core';

@Component({
  selector: 'app-redirect',
  template: '', // Empty template since we only redirect
  standalone: true
})
export class RedirectComponent implements OnInit {
  private authService = inject(AuthentificationService);
  private contextService = inject(ContextService);
  private navigationService = inject(NavigationService);
  private router = inject(Router);

  ngOnInit(): void {
    if (this.authService.authenticated) {
      this.contextService.goStartingPage();
    } else {
      this.router.navigateByUrl(this.navigationService.getSigninUrl());
    }
  }
}

